import { cva } from '@vizit/theme';

const rowClasses = cva({
  base: [
    'group bg-white transition-all duration-150',
    'focus-visible:outline-none',
    '[&[data-focus-visible]]:outline-2 [&[data-focus-visible]]:outline [&[data-focus-visible]]:outline-brand-600 [&[data-focus-visible]]:outline-offset-[-2px]',
    'hover:bg-primary-hover',
  ],
  variants: {
    disabled: {
      false: '',
      true: 'cursor-not-allowed hover:bg-white',
    },
  },
});

export { rowClasses };
